/**
 * Le pictogramme de chaque formule de l'élève, posé sur l'avatar de l'en-tête : la table de l'ancien
 * en-tête (`offersImages`, `auth/PricingColumnM.js:21-23`), « plus » et « premium » sur les images
 * d'« essential » et d'« integral » comme aujourd'hui.
 */
import essential from "../../../../../../assets/offers/essential.png"
import initial from "../../../../../../assets/offers/initial.png"
import integral from "../../../../../../assets/offers/integral.png"
import { type StudentOfferKey } from "../../../adapters/student/shared/studentShellAdapter"

export const STUDENT_OFFER_IMAGES: Record<StudentOfferKey, number> = {
    plus: essential,
    premium: integral,
    initial,
    essential,
    integral,
}
